import { ButtonProps } from '@mui/material/Button';
import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { styled } from '@mui/material/styles';

export interface BasicButtonProps extends LoadingButtonProps {
    textVariantStyle?: 'capitalize' | 'uppercase' | 'lowercase' | 'none';
    ariaLabel?: string;
}

export const BasicButton = ({
    textVariantStyle = 'none',
    ariaLabel, // added aria label as part of initial accessibility
    ...props
}: BasicButtonProps) => {
    // eslint-disable-next-line no-unused-vars
    const StyledButton = styled(LoadingButton)<ButtonProps>(() => ({
        textTransform: textVariantStyle
    }));

    return (
        <StyledButton aria-label={ariaLabel} {...props}>
            {props.children}
        </StyledButton>
    );
};

export const ContinueStepButton = styled(BasicButton)(({ theme }) => ({
    '&.MuiButton-root': {
        height: '38px',
        padding: theme.spacing(1, 2),
        borderRadius: '999px',
        fontFamily: '"TT Commons Pro"',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '22px',
        '&:not(.Mui-disabled)': {
            backgroundColor: theme.palette.semantic.int.selected,
            color: theme.palette.semantic.text.inverse
        }
    }
}));
